import { CreditGrant } from '@/clients/types';
import { fmtCurrency } from '@/lib/currency';
import { fmtDate } from '@/lib/date';
import { Table } from '@mantine/core';

type Props = {
  credits: CreditGrant[];
};

export function CreditList({ credits }: Props) {
  return (
    <Table.ScrollContainer minWidth={520} className="plamo-stack-sm">
      <Table horizontalSpacing="lg">
        <Table.Thead>
          <Table.Tr>
            <Table.Th></Table.Th>
            <Table.Th>金額</Table.Th>
            <Table.Th>発行日</Table.Th>
            <Table.Th>有効期限</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {credits.map((credit, i) => (
            <Table.Tr key={i}>
              <Table.Td data-label="名目">{credit.name}</Table.Td>
              <Table.Td data-label="金額">{fmtCurrency(credit.amount, credit.currency)}</Table.Td>
              <Table.Td data-label="発行日">{fmtDate(credit?.effective_at)}</Table.Td>
              <Table.Td data-label="有効期限">{fmtDate(credit?.expires_at)}</Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Table.ScrollContainer>
  );
}
